__turbopack_context__.v({
  "actions": "HYXRGa_actions",
  "card": "HYXRGa_card",
  "cardFlat": "HYXRGa_cardFlat",
  "cardOutline": "HYXRGa_cardOutline",
  "compact": "HYXRGa_compact",
  "dotAnnouncement": "HYXRGa_dotAnnouncement",
  "dotFunding": "HYXRGa_dotFunding",
  "dotLaunch": "HYXRGa_dotLaunch",
  "dotMilestone": "HYXRGa_dotMilestone",
  "dotOther": "HYXRGa_dotOther",
  "dotPartnership": "HYXRGa_dotPartnership",
  "eventDot": "HYXRGa_eventDot",
  "eventLabel": "HYXRGa_eventLabel",
  "eventLabelCompact": "HYXRGa_eventLabelCompact",
  "eventType": "HYXRGa_eventType",
  "head": "HYXRGa_head",
  "headline": "HYXRGa_headline",
  "headlineCompact": "HYXRGa_headlineCompact",
  "logo": "HYXRGa_logo",
  "logoFallback": "HYXRGa_logoFallback",
  "meta": "HYXRGa_meta",
  "metaCompact": "HYXRGa_metaCompact",
  "metaLine": "HYXRGa_metaLine",
  "sep": "HYXRGa_sep",
  "showMore": "HYXRGa_showMore",
  "source": "HYXRGa_source",
  "summary": "HYXRGa_summary",
  "summaryCompact": "HYXRGa_summaryCompact",
  "summaryMeasure": "HYXRGa_summaryMeasure",
  "summaryTruncated": "HYXRGa_summaryTruncated",
  "summaryWrap": "HYXRGa_summaryWrap",
  "teamName": "HYXRGa_teamName",
  "time": "HYXRGa_time",
  "upvote": "HYXRGa_upvote",
  "upvoteActive": "HYXRGa_upvoteActive",
  "viewCount": "HYXRGa_viewCount",
});
